"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfectiousDiseaseTestType = void 0;
exports.instanceOfInfectiousDiseaseTestType = instanceOfInfectiousDiseaseTestType;
exports.InfectiousDiseaseTestTypeFromJSON = InfectiousDiseaseTestTypeFromJSON;
exports.InfectiousDiseaseTestTypeFromJSONTyped = InfectiousDiseaseTestTypeFromJSONTyped;
exports.InfectiousDiseaseTestTypeToJSON = InfectiousDiseaseTestTypeToJSON;
exports.InfectiousDiseaseTestTypeToJSONTyped = InfectiousDiseaseTestTypeToJSONTyped;
/**
 *
 * @export
 */
exports.InfectiousDiseaseTestType = {
    Mantoux: 'MANTOUX'
};
function instanceOfInfectiousDiseaseTestType(value) {
    for (const key in exports.InfectiousDiseaseTestType) {
        if (Object.prototype.hasOwnProperty.call(exports.InfectiousDiseaseTestType, key)) {
            if (exports.InfectiousDiseaseTestType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function InfectiousDiseaseTestTypeFromJSON(json) {
    return InfectiousDiseaseTestTypeFromJSONTyped(json, false);
}
function InfectiousDiseaseTestTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function InfectiousDiseaseTestTypeToJSON(value) {
    return value;
}
function InfectiousDiseaseTestTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=InfectiousDiseaseTestType.js.map